export default __webpack_public_path__ + "static/footer-purple-bg-7e8af3d301f1dab26d83c280f0340b5f.png";